import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@material-ui/icons/Search";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  paddingLeft: "0px",
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #cccccc",
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    border: "1px solid hsl(0, 0%, 70%)",
  },
  color: "#212529",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  color: "#cccccc",
  "&:hover": {
    color: "hsl(0, 0%, 70%)",
  },
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    minWidth: "250px",
    maxWidth: "500px",
    fontSize: 12,
    fontFamily: "Hind Siliguri, sans-serif",
  },
}));

export default function SearchBar(props) {
  const handleSearch = (e) => {
    props.handleSearchValue(e.target.value);
  };

  // Calculate dynamic width based on placeholder length
  const placeholderLength = props.placeholder?.length || 0;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Toolbar sx={{ width: "100%", paddingLeft: "0px !important" }}>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder={props.placeholder}
            inputProps={{ "aria-label": "search" }}
            value={props.value}
            onChange={(e) => handleSearch(e)}
            style={{
              width: placeholderLength > 25 ? "420px" : "280px",
            }}
          />
        </Search>
      </Toolbar>
    </Box>
  );
}
